/*
choixPAGE==0 : liste des groupes
choixPAGE==1 : un seul groupe, avec la liste des étudiants
choixPAGE==2 : modifier un groupe (fenêtre ?)
choixPAGE==3 : envoyer un groupe à un collègue (par mail)

*/
/*
installation:
- ajouter le dossier /fichiers/groupe/ et /fichiers/groupe/upload/
- table groupe
- table groupeEtudiant
- table groupeInvite
- table groupeQcm : idqcm, idgroupe
- ALTER TABLE `etudiant` CHANGE `idetudiantDuplicate` `idgroupe` INT( 11 ) NULL
DEFAULT NULL ;

*/
app.controller(
  'gpeCtrl',
  function (
    $rootScope, $scope, services, $location, ngTableParams, $filter,
    FileUploader, ServiceQcm, toastr, $q) {
    $scope.url_ = $rootScope.url_;

    $scope.choixPAGE = 0;
    $scope.data = [];
    $rootScope.listeGroupe = [];
    $scope.nouveauGroupe = '';

    /*************************************************************/
    $scope.init = function () {
      $scope.afficheFichier = 0;


      //$rootScope.listeGroupe = [{"id":1, "lib":"GRH", "nb":26 }, {"id":1,
      //"lib":"gmo", "tab":[4, 5, 25, 26] },{"id":2, "lib":"gcf-S3",
      //"lib":"gcf-S3", "tab":[7,8,9,1,5,4,7,8,15,151,152,153,154]}];
      services.listeGroupe(1)
        .then(function (data) {
          $scope.a = data.data;
          $rootScope.listeGroupe = data.data;
          $scope.listeGroupe = $rootScope.listeGroupe;

          toastr.info('___pas encore de groupe___');

          if ($rootScope.listeGroupe.length == 0) {
            $scope.afficheFichier = 0;
          }

          //----------------------------------------- def tableau des
          //étudiants
          if (typeof ($scope.data) ===
            'undefined') {  // eviter erreur du début
            $scope.data = [];
          }

          var nb_max = Math.max($rootScope.listeGroupe.length, 100);

          $scope.listeGroupe = $rootScope.listeGroupe;
          $scope.tableGroupe = new ngTableParams(
            {
              page: 1,    // show first page
              count: 10,  // count per page
              sorting: { id: 'lib' }
            },
            {
              total: $scope.listeGroupe.length,
              counts: [10, 25, nb_max],
              getData: function ($defer, params) {
                //$scope.var  = params//pour affichage uniquement (à
                // supprimer apres)  !!
                $scope.data = params.filter() ?
                  $filter('filter')(
                    $scope.listeGroupe, params.filter()) :
                  $scope.listeGroupe;
                $scope.data = params.sorting() ?
                  $filter('orderBy')($scope.data, params.orderBy()) :
                  $scope.listeGroupe;
                $scope.data = $scope.data.slice(
                  (params.page() - 1) * params.count(),
                  params.page() * params.count());
                $defer.resolve($scope.data);
              }


            });
          //----------------------------------------- def tableau des
          //étudiants
          $scope.listeEtudiant = [];
          var nb_max2 = Math.max($scope.listeEtudiant.length, 100);

          $scope.tableDesEtudiants = new ngTableParams(
            {
              page: 1,    // show first page
              count: 10,  // count per page
              sorting: { id: 'Numero' }
            },
            {
              total: $scope.listeEtudiant.length,
              counts: [10, 25, nb_max2],
              getData: function ($defer2, params2) {
                //$scope.var  = params//pour affichage uniquement (à
                // supprimer apres)  !!
                $scope.data2 = params2.filter() ?
                  $filter('filter')(
                    $scope.listeEtudiant, params2.filter()) :
                  $scope.listeEtudiant;
                $scope.data2 = params2.sorting() ?
                  $filter('orderBy')($scope.data2, params2.orderBy()) :
                  $scope.listeEtudiant;
                $scope.data2 = $scope.data2.slice(
                  (params2.page() - 1) * params2.count(),
                  params2.page() * params2.count());
                $defer2.resolve($scope.data2);
              }
            });
          //----------------------------------------- def tableau des
          //étudiants
        })
        .catch(function (response) { })
        .finally(function (data) { })
    };
    // }
    /*************************************************************/


    /*************************************************************/
    $scope.envoyerFichier = function () {
      if ($scope.afficheFichier == 0)
        $scope.afficheFichier = 1;
      else
        $scope.afficheFichier = 0;
    };

    /*************************************************************/
    $scope.toggleModal =
      function (val) {  // aller dans le menu "nouvel étudiant"
        $scope.afficheFichier = 0;

        // alert("ok, val="+typeof(val) );
        if (typeof (val) == 'number') {  // nouvel etudiant
          // astuce : id = id du qcm !!!
          $scope.etudiantModifie = {
            'id': $rootScope.qcmSelectionne.id,
            '': '',
            'prenom': '',
            'numero': ''
          };
          if (val == 0) $scope.choixPAGE = 0;
          // if (val==1) $scope.choixPAGE=4;

        } else {  // modification ou suppression d'un etudiant
          $scope.choixPAGE = 1;
          $scope.etudiantModifie = val;
        }
      }

    /*************************************************************/
    $scope.submit = function () {
      if ($scope.choixPAGE == 1) {  // étudiant

        if (typeof ($scope.etudiantModifie.numero) == 'undefined') {
          toastr.error('___Entrer un numéro d\'étudiant valide___');
          return
        } else if ($scope.etudiantModifie.numero == '') {
          toastr.error('___Entrer un numéro d\'étudiant valide___');
          return
        }

        services.ajouterETUDIANT($scope.etudiantModifie, 'groupe')
          .then(function (data) {
            toastr.info('___étudiant créé___');
            $rootScope.qcmSelectionne.listeGroupe.push({
              'idetudiant': $scope.etudiantModifie.idetudiant,
              'nom': $scope.etudiantModifie.nom,
              'prenom': $scope.etudiantModifie.prenom,
              'numero': $scope.etudiantModifie.numero,
              'idqcm': $rootScope.qcmSelectionne.id,
              'idetudiantDuplicate': null,
              'note20': null,
              'nbcopie': 0,
              'reponse': '((((((((((((((((((((((((((((((((((((((((((((',
              'moyenne': -100,
              'sommenote': -100,
              'tabIndiceCopie': [-1],
              'lib': ''
            })

            $scope.data = $rootScope.qcmSelectionne.listeGroupe
            $scope.tableDesEtudiants.reload();
            $scope.etudiantModifie = [];
          })
          .catch(function (response) { })
          .finally(function (data) { })

        $scope.choixPAGE = 3;
      }

      if ($scope.choixPAGE == 1) {  // modifié étudiant

        services.modifierETUDIANT($scope.etudiantModifie, 'groupe')
          .then(function (data) {
            for (i = 0; i < $rootScope.qcmSelectionne.listeGroupe.length;
              i++) {
              if ($rootScope.qcmSelectionne.listeGroupe[i].idetudiant ==
                $scope.etudiantModifie.idetudiant) {
                console.info('(+)')

                $rootScope.qcmSelectionne.listeGroupe[i].nom =
                  $scope.etudiantModifie.nom
                $rootScope.qcmSelectionne.listeGroupe[i].prenom =
                  $scope.etudiantModifie.prenom
                $rootScope.qcmSelectionne.listeGroupe[i].numero =
                  $scope.etudiantModifie.numero
                $scope.data = $rootScope.qcmSelectionne.listeGroupe
                $scope.tableDesEtudiants.reload();
                i = 50000
              }
            }
            $scope.etudiantModifie = [];
          })
          .catch(function (response) { })
          .finally(function (data) { })


        toastr.info('___étudiant modifié___');
        $scope.choixPAGE = 3;
      }
    };


    /*************************************************************/
    $scope.supprimerE =
      function (etudiant) {  // supprimer étudiant
        // astuce, idqcm = numero
        services.effacerETUDIANT(etudiant, 'groupe')
          .then(function (data) {
            // tenir à jour qcmSelectionne
            for (var i = 0; i < $scope.listeEtudiant.length; i++) {
              if ($scope.listeEtudiant[i].idetudiant == etudiant.idetudiant) {
                $scope.listeEtudiant.splice(i, 1);
                i = 500000;
              }
            }

            //$scope.data2 = $rootScope.qcmSelectionne.listeGroupe;
          })
          .catch(function (response) {
            toastr.error('___session expirée___');
            $scope.loader = 0;
            $location.path('/QCMscanner');
          })
          .finally(function (data) {
            $scope.tableDesEtudiants.reload();
          })
        //$scope.etudiantModifie = [];

      }
    /*************************************************************/
    $scope.deleteAll =
      function () {  // supprimer tous les étudiants
        // astuce, idqcm = numero
        services.effaceAllETUDIANTS($scope.groupeSelectionne.idGroupe, 'groupe')
          .then(function (data) {
            $scope.listeEtudiant = [];
            $scope.listeGroupe[0].nb = 0

            $scope.data = [];
            $scope.tableDesEtudiants.reload();
          })
          .catch(function (response) {
            toastr.error('___session expirée___');
            $scope.loader = 0;
            $location.path('/QCMscanner');
          })
          .finally(function (data) {

          })

        $scope.tableDesEtudiants.reload();

      }
    /*************************************************************/
    /*    suprimerDoublonsEtudiant = function(){
            nb = $rootScope.qcmSelectionne.listeGroupe.length
            if (nb<=1) return
            tab=new Array()
            nbEfface = 0
            for (i=0; i<nb-1; i++){
                for (j=i+1; j<nb; j++){
                    if
       (($rootScope.qcmSelectionne.listeGroupe[i].nom==$rootScope.qcmSelectionne.listeGroupe[j].nom)&&($rootScope.qcmSelectionne.listeGroupe[i].prenom==$rootScope.qcmSelectionne.listeGroupe[j].prenom)&&($rootScope.qcmSelectionne.listeGroupe[i].numero==$rootScope.qcmSelectionne.listeGroupe[j].numero)){
                        tab.push(j)
                        nbEfface++
                        j=nb// on quitte
                    }
                }
            }
            for (i=nbEfface-1; i>=0; i++){
                $rootScope.listeGroupe.splice($rootScope.listeGroupe.indexOf($rootScope.listeGroupe[tab[i]]),
       1);
            }
        }*/

    /*************************************************************/
    $scope.cancel2 =
      function () {
        //$scope.choixPAGE=3;
      }
    /******************************************************************************************************/
    $scope.cancel =
      function () {  // revenir à la liste des qcm
        //$rootScope.afficheListeQcm=1;
        $location.path('/0lst');
      }
    /******************************************************************************************************/
    $scope.afficher_copies =
      function (user) {
        $scope.choixPAGE = 3;
        toastr.warning('pas encore implémenté...')
      }
    //----------------------------------------------------------------------
    // FILTERS

    var uploader = $scope.uploader = new FileUploader({
      url: '/envoiEtudiant/',
      formData:
        [{ 'token': $rootScope.user.token, 'id': -100, 'param': 'groupe' }]
      // formData: [$rootScope.qcmSelectionne]
    });

    uploader.filters.push({
      name: 'customFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        return this.queue.length < 100;
      }
    });

    uploader.onWhenAddingFileFailed = function (
      item /*{File|FileLikeObject}*/, filter, options) {
      console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function (fileItem) {
      console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function (addedFileItems) {
      console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function (item) {
      if (item.file.size >= 1024 * 100) {  // limite 100ko
        toastr.error('___fichier trop gros___');
        // this.queue.length=0;
        var erreur = 1;
        return;
      }

      item.headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      };
      console.info('onBeforeUploadItem', item);
      var nbEtudiant_avant = 0;
    };
    uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function (progress) {
      console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers);
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers);
    };
    uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
      /*if (erreur==1) return;
      if (response.stdout=="pb: pas un fichier etudiant"){
          toastr.error("___Ce n'est pas un fichier de solution
      compatible___");
      }*/
    };
    uploader.onComplete = function (response, status, headers) {
      console.info('onComplete', response, status, headers);
    };

    uploader.onCompleteAll = function () {
      var deferred = $q.defer();

      try {
        console.log('onCompleteAll');
        var nbEtudiant_avant = $scope.listeEtudiant.length;
        services.listeGEtudiant($scope.groupeSelectionne.idGroupe)
          .then(function (data) {
            $scope.listeEtudiant = data.data;
            var v = $scope.listeEtudiant.length - nbEtudiant_avant;
            if (v < 0)
              toastr.error('___L\'importation des étudiants a échoué.___');
            else
              toastr.success(v + '___étudiants importés.___');
            $scope.tableDesEtudiants.reload();
            document.getElementById('myModalEtudiant').click();
            uploader.progress = 0;
            $scope.tableDesEtudiants.reload();
            $scope.loader = 0;
          })
      } catch (e) {
        deferred.reject(e);
      }  // try-catch

      $scope.afficheFichier = 0;

      return deferred.promise
    };

    //----------------------------------------------------------------------


    /******************************************************************************************************/
    $scope.editerG = function (groupe) {
      $scope.choixPAGE = 1;
      $scope.groupeSelectionne = groupe;
      uploader.formData[0].id = $scope.groupeSelectionne.idGroupe;
      // charger les étudiant du groupe
      services.listeGEtudiant(groupe.idGroupe)
        .then(function (data) {
          $scope.listeEtudiant = data.data;
          $scope.tableDesEtudiants.reload();
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })



      // afficher tableau des étudiants
      // possibilité de modifier le nom du groupe (tout sauf un nom qui existe
      // déjà pour ce prof)
    };
    /******************************************************************************************************/
    $scope.renommer = function (groupe) {  // avant la fenetre
      $scope.groupeCopie = angular.copy(groupe);
    };

    $scope.renommerG = function (groupe) {  // apres validation de la fenetre
      if (groupe.lib == '' || typeof (groupe.lib) === 'undefined') {
        toastr.error('___groupe non créé. Libellé vide___');
        return;
      }
      for (var i = 0; i < $scope.listeGroupe.length; i++) {
        if ($scope.listeGroupe[i].lib == groupe.lib) {
          toastr.error('___ce groupe existe déjà___');
          return;
        }
      }
      services.renommerG(groupe)
        .then(function (data) {
          if (data.data.e == 1)
            for (var i = 0; i < $scope.listeGroupe.length; i++) {
              if ($scope.listeGroupe[i].idGroupe == groupe.idGroupe) {
                $scope.listeGroupe[i].lib = groupe.lib;
                $scope.tableGroupe.reload();
                return;
              }
            }
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })

    };
    /******************************************************************************************************/
    $scope.renommerEnew = function (
      etudiant) {  // avant la fenetre "+" : NOUVEAU
      $scope.etudiantCopie = {
        'idetudiant': '',
        'nom': '',
        'prenom': '',
        'numero': '',
        'idgroupe': $scope.groupeSelectionne.idGroupe,
        'new': 1
      };
    };

    $scope.renommerE = function (etudiant) {  // avant la fenetre "Editer"
      // : MODIF
      $scope.etudiantCopie = etudiant;
      $scope.etudiantCopie.new = 0;
    };

    $scope.renommerEtudiant = function (etudiant) {  // apres validation de
      // la fenetre : NOUVEAU
      // ou MODIF
      if ($scope.etudiantCopie.new == 0) {
        services.modifierETUDIANT($scope.etudiantCopie, 'groupe')
          .then(function (data) {
            if (data.data.e > 0) {
              $scope.etudiantCopie = etudiant;
              $scope.listeEtudiant.splice(
                [$scope.listeEtudiant.indexOf(
                  { 'idetudiant': etudiant.idetudiant })],
                1, etudiant);
              document.getElementById('myModalNewEtudiant').click();
              $scope.tableDesEtudiants.reload();
            }
          })
          .catch(function (response) {
            toastr.error('___session expirée___');
            $scope.loader = 0;
            $location.path('/QCMscanner');
          })
          .finally(function (data) { })

      } else {
        services.ajouterETUDIANT(etudiant, 'groupe')
          .then(function (data) {
            alert(data.data.e);
            if (data.data.e > 0) {
              $scope.listeEtudiant.push({
                'idetudiant': data.data.e,
                'nom': etudiant.nom,
                'prenom': etudiant.prenom,
                'numero': etudiant.numero,
                'idgroupe': etudiant.idGroupe
              });
              document.getElementById('myModalNewEtudiant').click();
              $scope.tableDesEtudiants.reload();
            }
          })
          .catch(function (response) {
            toastr.error('___session expirée___');
            $scope.loader = 0;
            $location.path('/QCMscanner');
          })
          .finally(function (data) {
            $scope.tableDesEtudiants.reload();
          })
      }

    };
    /******************************************************************************************************/
    $scope.dupliquer = function (groupe) {  // AVANT dupliquer
      $scope.groupeCopie = angular.copy(groupe);
      $scope.boutonCreerGroupe = 0;
    };

    $scope.dupliquerG = function (g) {  // APRES dupliquer
      if (g.lib == '' || typeof (g.lib) === 'undefined') {
        toastr.error('___groupe non créé. Libellé vide___');
        return;
      }
      for (var i = 0; i < $scope.listeGroupe.length; i++) {
        if ($scope.listeGroupe[i].lib == g.lib) {
          toastr.error('___ce groupe existe déjà___');
          return;
        }
      }
      services.dupliquerG(g)
        .then(function (data) {
          $rootScope.listeGroupe.push(
            { 'id': data.data.idGroupe, 'lib': g.lib, 'nb': g.nb });
          $scope.listeGroupe = $rootScope.listeGroupe;
          $scope.tableGroupe.reload();
          $scope.nouveauGroupe = '';
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })


    };
    /******************************************************************************************************/
    $scope.inviter = function (groupe) {  // AVANT inviter
      alert('debut')
      $scope.emails =
        'Christophe DABANCOURT <christophe.dabancourt@laposte.net>';

    };

    $scope.inviterG = function (g) {  // APRES inviter
      // (envoyer mail)
      services.dupliquerG(g)
        .then(function (data) {
          $rootScope.listeGroupe.push(
            { 'id': data.data.idGroupe, 'lib': g.lib, 'nb': g.nb });
          $scope.listeGroupe = $rootScope.listeGroupe;
          $scope.tableGroupe.reload();
          $scope.nouveauGroupe = '';
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })

    };

    /******************************************************************************************************

        $scope.dupliquerG =
    function(groupe){
            // copie sur le
    serveur du groupe  "GMO-S3" ->
    "GMO-S3 (copie)", ou  "GMO-S3
    (copie 2)"... var
    nom=groupe.lib+" (copie)"; var
    lg=$scope.listeGroupe.length;
        var trouve=1;
        var i=0;
        var nbCopie=2;
        while (trouve){
            trouve=0;
            for (i=0;i<lg; i++){
                //alert("lib="+$scope.listeGroupe[i].lib+"
    =? "+nom) if
    (nom==$scope.listeGroupe[i].lib){
                    //alert("trouve
    !!!! on recommence");
                    trouve=1;
                    i=lg;
                }
            }
            if (trouve==1){
                if
    (nom==groupe.lib+" (copie)")
    nbCopie=2; else nbCopie++;
                nom=groupe.lib+"
    (copie "+nbCopie+")";
            }
        }

        $rootScope.listeGroupe.push({"id":45600,
    "lib":nom,
    "tab":angular.copy(groupe.tab)
    }); $scope.listeGroupe =
    $rootScope.listeGroupe;
        $scope.tableGroupe.reload();

        // !!! les étudiants d'un
    groupe ne sont pas les
    étudiants d'un QCM qui existe

    }
    ******************************************************************************************************/
    $scope.partagerG = function (groupe) {
      $scope.choixPAGE = 3;
      // demander la liste des mails de collègues (pour quand ils se
      // connecteront...)
      toastr.warning('pas encore implémenté...');
    };
    /******************************************************************************************************/
    $scope.supprimerG = function (groupe) {
      // on supprime la liste du compte principale - mettre une option :
      // "supprimer également cette liste si elle a été partagée avec des
      // collègues"
      // le groupe est supprimé, mais pas les QCM et les étudiant associés aux
      // qcm qui ont été fait

      services.effaceGroupe(groupe.idGroupe)
        .then(function (data) {
          $scope.a = data.data;
          $rootScope.listeGroupe = data.data;
          $scope.listeGroupe = $rootScope.listeGroupe;
          toastr.info('___groupe créé___');
          $scope.tableGroupe.reload();
          $scope.nouveauGroupe = '';
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })



      var lg = $scope.listeGroupe.length;
      var i = 0;
      for (i = 0; i < lg; i++) {
        if (groupe.lib == $scope.listeGroupe[i].lib) {
          $rootScope.listeGroupe.splice(i, 1);
          $scope.listeGroupe = $rootScope.listeGroupe;
          i = lg;
          $scope.tableGroupe.reload();
        }
      }
    };
    /******************************************************************************************************/
    $scope.sauver = function (g) {
      // on supprime la liste du compte principale - mettre une option :
      // "supprimer également cette liste si elle a été partagée avec des
      // collègues"
      // le groupe est supprimé, mais pas les QCM et les étudiant associés aux
      // qcm qui ont été fait
      $scope.choixPAGE = 0;
      if (g == '' || typeof (g) === 'undefined') {
        toastr.error('___groupe non créé. Libellé vide___');
        return;
      }
      for (var i = 0; i < $scope.listeGroupe.length; i++) {
        if ($scope.listeGroupe[i].lib == g) {
          toastr.error('___ce groupe existe déjà___');
          return;
        }
      }
      services.newGroupe(g)
        .then(function (data) {
          $scope.a = data.data;
          $rootScope.listeGroupe = data.data;
          $scope.listeGroupe = $rootScope.listeGroupe;
          toastr.info('___groupe créé___');
          $scope.tableGroupe.reload();
          $scope.nouveauGroupe = '';
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })
    };
    /******************************************************************************************************/
    $scope.gotoListeQcm = function () {
      $location.path('/0lst');
    };
    /******************************************************************************************************/
    $scope.gotoListeG = function () {
      services.listeGroupe(1)
        .then(function (data) {
          $scope.a = data.data;
          $rootScope.listeGroupe = data.data;
          $scope.listeGroupe = $rootScope.listeGroupe;
          $scope.tableGroupe.reload();

          $scope.choixPAGE = 0;
        })
        .catch(function (response) {
          toastr.error('___session expirée___');
          $scope.loader = 0;
          $location.path('/QCMscanner');
        })
        .finally(function (data) { })
    };
    /******************************************************************************************************/
    $scope.change = function (nouveauGroupe) {
      if (nouveauGroupe == '' || typeof (nouveauGroupe) === 'undefined')
        $scope.boutonCreerGroupe = 0;
      else {
        $scope.boutonCreerGroupe = 1;
        for (var i = 0; i < $scope.listeGroupe.length; i++) {
          if ($scope.listeGroupe[i].lib == nouveauGroupe) {
            $scope.boutonCreerGroupe = 0;
            i = 50000;
          }
        }
      }
    };
    /******************************************************************************************************/
    function extractEmails(text) {
      return text.match(
        /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
    };

    $scope.changeText = function (t) {
      $scope.emails = extractEmails(t);
    };
    /*************************************************************/
  });
